import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { take } from 'rxjs';
import { TimeEntryCategorySum } from '../../entities/timeEntryCategorySum/timeEntryCategorySum';
import * as fromGraphQl from './graphql';

@Component({
  selector: 'app-time-entry-categories-sum-view, [app-time-entry-categories-sum-view]',
  templateUrl: './time-entry-categories-sum-view.component.html',
  styleUrls: ['./time-entry-categories-sum-view.component.scss'],
})
export class TimeEntryCategoriesSumComponent implements OnChanges {

  @Input() ownerId: string | undefined;

  public timeEntryCategoriesSums: TimeEntryCategorySum[];

  constructor(
    private apollo: Apollo,
  ) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.ownerId) {
    this.apollo.query<fromGraphQl.TimeEntrCategoriesSumQueryResponse>({
      fetchPolicy: 'network-only',
      query: fromGraphQl.TIME_ENTRY_CATEGORY_SUM_QUERY,
      variables: {
        ownerId: this.ownerId
      },
    }).pipe(
      take(1)
    ).subscribe( (data) => {
      console.log('data', data);
      if(data?.data?.timeEntryCategoriesSum) {
        this.timeEntryCategoriesSums = TimeEntryCategorySum.createTimeEntryCategorySums(data?.data?.timeEntryCategoriesSum);
      }
    });
    }
  }

}
